import React from "react";
import { Card, CopyHash, KeyValueList } from "@sscs/ui";
import { humanReadableBytes } from "@sscs/utils";
import { useSearchParams } from "react-router";
import { FILE_BROWSER_ROUTES, ROOT_FILE_PATH } from "../../../constants";
import { getSha256 } from "../../../utils";
import { LinkToReportTab } from "../../common";
import { generateFileBrowserLink } from "../../utils";
import styles from "./sampleSummary.module.scss";
const SampleSummary = ({ secretId, componentId, file, }) => {
    var _a;
    const [searchParams] = useSearchParams();
    const fileTypeInfo = `${file.type}/${file.subtype}${file.format ? `/${file.format}` : ""}`;
    const sha256 = getSha256(file);
    return (React.createElement(Card.Card, null,
        React.createElement(Card.Title, null, "File information"),
        React.createElement(Card.Content, null, React.createElement(KeyValueList, { className: styles["file-information"], list: {
                Name: (React.createElement(LinkToReportTab, { id: `file-issues-${secretId}`, to: generateFileBrowserLink({
                        searchParams,
                        componentId,
                        componentPath: file.path,
                        fileBrowserPage: FILE_BROWSER_ROUTES.SECRETS_ROUTE,
                    }), color: "link" }, file.name)),
                "File type": fileTypeInfo,
                Size: humanReadableBytes(Number(file.size)),
                Path: (_a = file.path) !== null && _a !== void 0 ? _a : ROOT_FILE_PATH,
                SHA256: (React.createElement("div", { className: styles.sha256 },
                    React.createElement("span", null, sha256),
                    React.createElement(CopyHash, { id: `sbom-component-${secretId}-copy-hash-to-clipboard`, sha256: sha256 }))),
            } }))));
};
export default SampleSummary;
//# sourceMappingURL=SampleSummary.js.map